import React from 'react';
import * as ws from '@/inpatient-dashboard/services/websocket';
import WebSocketContext from './websocketContext';

/**
 * <WebSocketProvider> component
 */
const WebSocketProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [wsState, setWSState] = React.useState(ws.defaultWebSocketState);

  // Allow graphql service to set this component state on
  // WebSocket state changes (mainly due to token refreshes)
  React.useEffect(() => {
    ws.setWebSocketSetterRef(setWSState);
    // Sync any state change that fired before the setter was registered
    setWSState({ ...ws.defaultWebSocketState });
    return () => {
      ws.setWebSocketSetterRef(() => {});
    };
  }, [setWSState]);

  return (
    <WebSocketContext.Provider value={wsState}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
